import React, { useEffect, useMemo, useState } from 'react';
import { ChatbotDataContext } from './ChatbotDataContext';
import { useLivePersonConnectionRequest } from '../LivePersonService/useLivePersonConnectionRequest';
import analytics from '../analytics';
let chatRguid = '';
/**
 * Data provider for Chatbot
 * @public
 */
export const ChatbotDataProvider = props => {
  const {
    chatContainerHeight,
    setCachedMessages,
    setCachedPrompts,
    cachedMessages = [],
    // Sending these will cause error in openAI but are good for display
    cachedPrompts = [],
    // Safe to send to openAI
    submitChatMessagesPayload,
    handleMarkerResponse,
    fetchRequestOptions,
    markerComponents,
    logFirstMessageSubmitted,
    logCustomerCarePhoneNumberDisplayed,
    logCustomerCarePhoneNumberClicked,
    enableVoice,
    enableVoiceTooltip,
    sentenceArrayBuilder,
    speechFetcher,
    quickActions,
    quickActionsStackVariant,
    isMobile,
    livePersonOptions,
    setiValues,
    debugMode,
    discoveryCitySelected,
    speechFetchRequestOptions,
    transcriptionFetchRequestOptions,
    audioPlayerRef,
    openErrorComponent,
    setOpenErrorComponent,
    isDev,
    setChatMessages,
    chatMessages,
    prompts,
    setPrompts,
    setLoadingStatus,
    setLoadMoreMessages,
    isLoading,
    loadMoreMessages,
    shouldDisplayGenHotelFeature
  } = props;
  const {
    pushPrompt
  } = submitChatMessagesPayload !== null && submitChatMessagesPayload !== void 0 ? submitChatMessagesPayload : {};
  const [errorMessage, setErrorMessage] = useState('');
  // ChatMessages keeps the data that would display to the user
  // Prompts keeps the data that would submit to the api
  const [isDisablingInput, setIsDisablingInputValue] = useState(false);
  const [fullStreamingTexts, setStreamingText] = useState('');
  // Live Person state
  const [livePersonAgentInitial, setLivePersonAgentInitial] = useState('AG');
  const [livePersonAgentName, setLivePersonAgentName] = useState('agent');
  const [lpUserFirstName, setLPUserFirstName] = useState('');
  const [lpUserLastName, setLPUserLastName] = useState('');
  const [livePersonConversationId, setLivePersonConversationId] = useState('');
  const [isLPUserFormSubmitted, setIsLPUserFormSubmitted] = useState(false);
  const [isLivePersonEnabled, setIsLivePersonEnabled] = useState(false);
  const [isLivePersonSessionActive, setIsLivePersonSessionActive] = useState(false);
  const [closeLpChat, setCloseLpChat] = useState(false);
  const [chatSummary, setChatSummary] = useState('');
  const funcValues = useMemo(() => ({
    setErrorMessage,
    setLoadingStatus,
    setChatMessages,
    setPrompts,
    setIsDisablingInputValue,
    setStreamingText,
    setLivePersonAgentInitial,
    setLivePersonAgentName,
    setLPUserFirstName,
    setLPUserLastName,
    setIsLPUserFormSubmitted,
    setIsLivePersonEnabled,
    setChatSummary,
    setIsLivePersonSessionActive,
    setCloseLpChat,
    setOpenErrorComponent,
    setLoadMoreMessages
  }), [setErrorMessage, setLoadingStatus, setChatMessages, setPrompts, setIsDisablingInputValue, setStreamingText, setLivePersonAgentInitial, setLivePersonAgentName, setLPUserFirstName, setLPUserLastName, setIsLPUserFormSubmitted, setIsLivePersonEnabled, setChatSummary, setIsLivePersonSessionActive, setCloseLpChat, setOpenErrorComponent, setLoadMoreMessages]);
  // Submit initiate message to start the conversation
  // this initial request require user first and last name
  const livePersonConnectionRequest = useLivePersonConnectionRequest({
    chatMessages,
    setChatMessages,
    setCachedMessages,
    setIsDisablingInputValue,
    setStreamingText,
    setErrorMessage,
    livePersonOptions,
    lpUserFirstName,
    lpUserLastName,
    setLivePersonAgentInitial,
    setLivePersonAgentName,
    setLivePersonConversationId,
    isLivePersonEnabled,
    setIsLivePersonEnabled,
    livePersonConversationId,
    chatSummary,
    isLivePersonSessionActive,
    setIsLivePersonSessionActive,
    closeLpChat,
    setCloseLpChat,
    livePersonAgentName
  });
  // Preserve chatRguid from submitChatMessagesPayload
  // So on client side, once the Dialog is closed and reopen, there will be a new rguid
  // we need keep to use the same chatRguid.
  if (!chatRguid) {
    chatRguid = submitChatMessagesPayload.rguid;
  } else {
    submitChatMessagesPayload.rguid = chatRguid;
  }
  const contextValues = Object.assign({
    discoveryCitySelected,
    chatContainerHeight,
    setCachedMessages,
    setCachedPrompts,
    cachedMessages,
    cachedPrompts,
    submitChatMessagesPayload,
    handleMarkerResponse,
    fetchRequestOptions,
    markerComponents,
    logFirstMessageSubmitted,
    logCustomerCarePhoneNumberDisplayed,
    logCustomerCarePhoneNumberClicked,
    quickActions,
    quickActionsStackVariant,
    isMobile,
    livePersonOptions,
    debugMode,
    openErrorComponent,
    isDev,
    loadMoreMessages,
    // global state values
    errorMessage,
    isLoading,
    chatMessages,
    prompts,
    isDisablingInput,
    fullStreamingTexts,
    livePersonAgentInitial,
    livePersonAgentName,
    lpUserFirstName,
    lpUserLastName,
    livePersonConnectionRequest,
    livePersonConversationId,
    isLPUserFormSubmitted,
    isLivePersonEnabled,
    isLivePersonSessionActive,
    closeLpChat,
    enableVoice,
    enableVoiceTooltip,
    sentenceArrayBuilder,
    speechFetcher,
    setiValues,
    speechFetchRequestOptions,
    transcriptionFetchRequestOptions,
    pushPrompt,
    audioPlayerRef,
    shouldDisplayGenHotelFeature
  }, funcValues);
  useEffect(() => {
    analytics.init(contextValues);
  }, []);
  return React.createElement(ChatbotDataContext.Provider, {
    value: contextValues
  }, props.children);
};